import ResponseFeedback from '../ResponseFeedback';
import './style.css';
import { Bubble } from '@chatui/core';

interface ResponseContainerProps {
  children: React.ReactNode;
  call_id?: string;
  handleFeedback: (call_id: string, feedback: string) => void;
}
const ResponseContainer = (props: ResponseContainerProps) => {
  const { children, call_id, handleFeedback } = props;
  return (
    <Bubble>
      {children}
      {call_id && (
        <ResponseFeedback
          sendFeedback={(feedback) => {
            handleFeedback(call_id, feedback);
          }}
        />
      )}
    </Bubble>
  );
};

export default ResponseContainer;
